import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-chart-content-loader',
  templateUrl: './chart-content-loader.component.html',
  styleUrls: ['./chart-content-loader.component.scss']
})
export class ChartContentLoaderComponent {
  @Input() error: string | null = null;
  @Input() isLoading = true;
  @ContentChild('loading') loadingTemplate: TemplateRef<any> | null = null;
  @ContentChild('error') errorTemplate: TemplateRef<any> | null = null;
}
